import {
    IExpressionResolver, IExpressionResolution, failedExpressionResolution,
    ResolutionErrorKind, successfulExpressionResolution, IResolutionError
} from 'app/model/expressions/expression-resolution';
import { ScalarExpression, ExpressionCategory } from './expression';
import { Owned } from 'app/model/base/named';

/**
 * Resolves 'expressions' that do not contain an @ expression.
 */
export class NoExpressionResolver implements IExpressionResolver {
    /**
     * Initializes a new instance of the NoExpressionResolver class.
     */

    public isOfType(expression: string, ignoreStart?: boolean): boolean {
        // Having the @ characters in string literals is ok.
        return true;
    }

    public resolve(expression: string, ignoreStart?: boolean): IExpressionResolution {
        if (!this.isOfType(expression, ignoreStart)) {
            return failedExpressionResolution(expression, { kind: ResolutionErrorKind.Unrecognized, details: expression });
        }

        // all expressions are valid!
        return successfulExpressionResolution(
            expression,
            new ScalarExpression(
                ExpressionCategory.None, 'No expression', expression,
                'No expression', 'String'), []);
    }

    public checkApplicability(entity: Owned): { isApplicable: boolean, error?: IResolutionError } {
        return { isApplicable: true };
    }
}
